import { render, staticRenderFns } from "./UserKeyAccessTab.vue?vue&type=template&id=cae66056&"
import script from "./UserKeyAccessTab.vue?vue&type=script&lang=ts&"
export * from "./UserKeyAccessTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports